import axios from 'axios';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import '../styles/Login.css';

function TenantLogin() {
  const { codigo } = useParams();
  const tenantSlug = (codigo || '').toLowerCase();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [tenantInfo, setTenantInfo] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    // Cargar información del tenant
    const loadTenantInfo = async () => {
      try {
        const response = await axios.get(`/api/tenants/${tenantSlug}/info`, {
          headers: { 'Cache-Control': 'no-cache' }
        });
        setTenantInfo(response.data);
      } catch (error) {
        console.error('Error cargando info del tenant:', error);
        setError('Cliente no encontrado');
      }
    };

    if (codigo) {
      loadTenantInfo();
    }
  }, [codigo]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      // Intentar login como usuario del tenant (ruta estándar /auth/login)
      const apiBase = '/api';
      const response = await axios.post(`${apiBase}/auth/login`, {
        username,
        password,
        tenant_code: tenantSlug
      });

      if (response.data?.access_token) {
        localStorage.setItem('token', response.data.access_token);
        localStorage.setItem('user', JSON.stringify(response.data.usuario));
        localStorage.setItem('tenant_codigo', tenantSlug);

        const tenantInfoToStore = {
          ...(tenantInfo || {}),
          ...(response.data.tenant || {})
        };
        localStorage.setItem('tenant_info', JSON.stringify(tenantInfoToStore));

        setLoading(false);
        navigate(`/${tenantSlug}/dashboard`);
        return;
      }
    } catch (errUsuario) {
      // Si falla por credenciales, intentar login como administrador del tenant
      if (errUsuario.response?.status !== 401) {
        setError(errUsuario.response?.data?.error || 'Error al iniciar sesión');
        setLoading(false);
        return;
      }

      try {
        const responseAdmin = await axios.post(`${apiBase}/tenants/${tenantSlug}/login`, {
          username,
          password
        });

        localStorage.setItem('token', responseAdmin.data.access_token);
        localStorage.setItem('user', JSON.stringify(responseAdmin.data.user));
        localStorage.setItem('tenant_codigo', tenantSlug);
        const tenantInfoToStore = {
          ...(tenantInfo || {}),
          ...(responseAdmin.data.tenant || {})
        };
        localStorage.setItem('tenant_info', JSON.stringify(tenantInfoToStore));

        navigate(`/${tenantSlug}/dashboard`);
        return;
      } catch (errAdmin) {
        setError(errAdmin.response?.data?.error || 'Credenciales inválidas');
      } finally {
        setLoading(false);
      }
    }

    setLoading(false);
  };

  if (error && !tenantInfo) {
    return (
      <div className="login-container">
        <div className="login-card">
          <div className="error-message">
            <i className="fas fa-exclamation-circle"></i>
            <h2>Cliente no encontrado</h2>
            <p>El código "{codigo}" no está registrado en el sistema.</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <h1>{tenantInfo?.nombre_negocio || 'Cargando...'}</h1>
          <p>Sistema de Préstamos</p>
        </div>

        {error && (
          <div className="alert alert-danger">
            <i className="fas fa-exclamation-circle"></i> {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label>
              <i className="fas fa-user"></i> Usuario
            </label>
            <input
              type="text"
              className="form-control"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Ingrese su usuario"
              required
              autoFocus
            />
          </div>

          <div className="form-group">
            <label>
              <i className="fas fa-lock"></i> Contraseña
            </label>
            <input
              type="password"
              className="form-control"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Ingrese su contraseña"
              required
            />
          </div>

          <button
            type="submit"
            className="btn btn-primary btn-block"
            disabled={loading}
          >
            {loading ? (
              <>
                <i className="fas fa-spinner fa-spin"></i> Ingresando...
              </>
            ) : (
              <>
                <i className="fas fa-sign-in-alt"></i> Ingresar
              </>
            )}
          </button>
        </form>

        <div className="login-footer">
          <p className="text-muted">
            <i className="fas fa-building"></i> {codigo}
          </p>
        </div>
      </div>
    </div>
  );
}

export default TenantLogin;
